import React from "react";
import "./App.css";
import Header from "./header/Header";
import ContactForm from "./Form/ContactForm";
import "./i18n";

function App() {
  const bg = `${process.env.PUBLIC_URL}/background-image.webp`;
  return (
    <div
      className="main-container"
      style={{
        backgroundImage: `linear-gradient(rgba(0,0,0,0.419),rgba(0,0,0,0.436)),url(${bg})`
      }}
    >
      <Header />

      <main style={{ width: "100%", padding: "60px 0", marginTop: "150px" }}>
        <ContactForm />
      </main>
    </div>
  );
}

export default App;
